import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indication',
})
export class IndicationPipe implements PipeTransform {
  transform(value: number | string, ...args: unknown[]): unknown {
    if (Number(value) >= 0) {
      return value;
    } else {
      return `(${Math.abs(Number(value))})`;
    }
  }
}
